import { VendorLoginPageForm } from '../components/Auth-Designer/VendorLoginPageForm';

const VendorLoginPage = () => {
  return (
    <main>
      <VendorLoginPageForm />
    </main>
  );
};

export default VendorLoginPage;